
    import './styles.scoped.css';
    export default {
  "icon-shake": "awsui_icon-shake_1cbgc_g6zdm_98",
  "awsui-motion-shake-horizontally": "awsui_awsui-motion-shake-horizontally_1cbgc_g6zdm_1",
  "container-fade-in": "awsui_container-fade-in_1cbgc_g6zdm_126",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_1cbgc_g6zdm_1",
  "root": "awsui_root_1cbgc_g6zdm_148",
  "status-error": "awsui_status-error_1cbgc_g6zdm_155",
  "status-warning": "awsui_status-warning_1cbgc_g6zdm_158",
  "status-success": "awsui_status-success_1cbgc_g6zdm_161",
  "status-info": "awsui_status-info_1cbgc_g6zdm_164",
  "status-stopped": "awsui_status-stopped_1cbgc_g6zdm_167",
  "status-pending": "awsui_status-pending_1cbgc_g6zdm_170",
  "status-in-progress": "awsui_status-in-progress_1cbgc_g6zdm_173",
  "status-loading": "awsui_status-loading_1cbgc_g6zdm_176",
  "color-override-red": "awsui_color-override-red_1cbgc_g6zdm_179",
  "color-override-grey": "awsui_color-override-grey_1cbgc_g6zdm_182",
  "color-override-blue": "awsui_color-override-blue_1cbgc_g6zdm_185",
  "color-override-green": "awsui_color-override-green_1cbgc_g6zdm_188",
  "icon": "awsui_icon_1cbgc_g6zdm_98",
  "container": "awsui_container_1cbgc_g6zdm_126",
  "overflow-ellipsis": "awsui_overflow-ellipsis_1cbgc_g6zdm_202"
};
  